// import vFast from './fastclick.js';
import vVisible from './v-visible.js';
import footer from './footer.js';
export { vVisible, footer };
